import React from 'react'
import BlockContent from '@sanity/block-content-to-react'

import Image from '@/image.js'

export const serializer = {
  types: {
    block: props => {
      const style = props.node.style || 'normal'
      if (/^h\d/.test(style)) {
        switch (style) {
          case 'h2':
            return <h2 className='mb0 pb0 mt0 py05'>{props.children}</h2>
          default:
            return
        }
      }
      return style === 'blockquote' ? (
        <blockquote>{props.children}</blockquote>
      ) : (
          <p>{props.children}</p>
        )
    }
  },
}

const ImageText = ({ content }) => {
  return (
    <div className='x image__text-wrapper py1'>
      <div className='container--xl ma'>
        <div className='f jcb fw aic x image__text-flex'>
          <Image imageId={content.imageId} className='x image__image' />
          <div className='image__text pt15 px15 pb0'>
            <BlockContent blocks={content.description} serializers={serializer} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ImageText
